import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import jaLocale from "@fullcalendar/core/locales/ja";
import koLocale from "@fullcalendar/core/locales/ko";
import "../calendar.css";
import { DatesSetArg, EventContentArg } from "@fullcalendar/core/index.js";
import { dailyBalance } from "../utils/dailyBalance";
import { toCurrency } from "../utils/currency";
import interactionPlugin, { DateClickArg } from "@fullcalendar/interaction"; // a plugin
import { formatDate, formatMonth } from "../utils/formatting";
import { theme } from "../theme/theme";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store/store";
import { setCurrentMonth, setCurrentDay } from "../store/appSlice";

interface CalendarProps {
  dailyListWindowView: () => void;
}

const Calendar = ({ dailyListWindowView }: CalendarProps) => {
  const {
    wholeTransactions,
    transactions,
    currentMonth,
    currentDay,
    userInfo,
    baseLanguage,
  } = useSelector((state: RootState) => state.app);
  const dispatch = useDispatch();
  const language = userInfo?.language ?? baseLanguage;

  console.log("Calendar:wholeTransactions: ", wholeTransactions);
  // console.log("Calendar:transactions: ", JSON.stringify(transactions));
  const dailySummary = dailyBalance(transactions).map((item) => {
    return {
      date: item.date,
      income: toCurrency(item.income),
      expense: toCurrency(item.expense),
      balance: toCurrency(item.balance),
    };
  });
  // console.log("Calendar:dailyBalance: ", dailyBalance);
  // console.log("Calendar:dailyBalance: ", JSON.stringify(dailyBalance));

  // const events = [
  //   {
  //     title: "Meeting",
  //     start: "2026-04-21",
  //     income: "1000",
  //     expense: "800",
  //     balance: "200",
  //     /* 選択日付に背景を設定 */
  //     display: "background", backgroundColor: "red"
  //   },
  // ];

  let selectedDay = {};
  if (formatDate(new Date()) !== currentDay) {
    selectedDay = {
      start: currentDay,
      display: "background",
      backgroundColor: theme.palette.grey[400],
    };
  }

  const renderEventContent = (eI: EventContentArg) => {
    return (
      <div>
        <div className="money" id="event-income">
          {eI.event.extendedProps.income}
        </div>
        <div className="money" id="event-expense">
          {eI.event.extendedProps.expense}
        </div>
        <div className="money" id="event-balance">
          {eI.event.extendedProps.balance}
        </div>
      </div>
    );
  };

  // 月の日付を取得（今日、先月、例月ボータンで発火）
  const handleDateSet = (dateSetInfo: DatesSetArg) => {
    // console.log("handleDateSet:", dateSetInfo);
    // console.log("handleDateSet:", dateSetInfo.view.currentStart);
    const currentMonth = dateSetInfo.view.currentStart;
    // setCurrentMonth(currentMonth);
    dispatch(setCurrentMonth(currentMonth));

    const currentDate = new Date();
    if (formatMonth(currentDate) === formatMonth(currentMonth)) {
      // setCurrentDay(formatDate(currentDate));
      dispatch(setCurrentDay(formatDate(currentDate)));
    }
  };

  const handleDateClick = (dateInfo: DateClickArg) => {
    // console.log("handleDateClick:", dateInfo);
    dispatch(setCurrentDay(dateInfo.dateStr));

    dailyListWindowView();
  };

  return (
    <FullCalendar
      locale={
        !language || language === "ja"
          ? jaLocale
          : language === "ko"
            ? koLocale
            : language === "en"
              ? ""
              : jaLocale
      }
      height={"auto"}
      plugins={[dayGridPlugin, interactionPlugin]}
      initialView="dayGridMonth"
      events={[...dailySummary, selectedDay]}
      // events={dailySummary}
      eventContent={renderEventContent}
      datesSet={handleDateSet}
      dateClick={handleDateClick}
    />
  );
};

export default Calendar;
